import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import { useAuth } from '../../contexts/AuthContext';
import './Sidebar.css';
import logo from '../../assets/logo.jpg';
import logoMini from '../../assets/logo_mini.jpg';
import { BsPeople, BsBriefcase, BsGraphUp, BsCalculator, BsWallet2, BsArrowLeftRight, BsJournalText } from 'react-icons/bs';
import { MdOutlineHomeWork } from 'react-icons/md';
import { IconType } from 'react-icons';

const Sidebar: React.FC = () => {
  const location = useLocation();
  const { sidebarCollapsed, toggleSidebar } = useTheme();
  const { user } = useAuth();

  const isAdmin = user?.userType === 'ADMINISTRATOR';

  const allMenuItems: { path: string; label: string; Icon: IconType; adminOnly?: boolean }[] = [
    { path: '/usuarios', label: 'Usuarios', Icon: BsPeople, adminOnly: true },
    { path: '/productos', label: 'Productos', Icon: BsBriefcase, adminOnly: true },
    { path: '/inversiones', label: 'Inversiones', Icon: BsGraphUp },
    { path: '/cuadro-amortizacion', label: 'Calendario de pagos', Icon: BsCalculator },
    { path: '/amortizaciones', label: 'Amortizaciones', Icon: BsArrowLeftRight, adminOnly: true },
    { path: '/movimientos', label: 'Movimientos', Icon: BsJournalText, adminOnly: true },
    { path: '/seguimiento-cra', label: 'Seguimiento CRA', Icon: MdOutlineHomeWork },
    { path: '/cartera-revalorizacion', label: 'Cartera Tickets', Icon: BsWallet2 },
  ];

  const menuItems = allMenuItems.filter(item => !item.adminOnly || isAdmin);

  return (
    <aside className={`sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <Link to="/" className="logo-link" title="Ir al inicio">
          <img
            src={sidebarCollapsed ? logoMini : logo}
            alt="Club Participa"
            className={`sidebar-logo ${sidebarCollapsed ? 'mini' : ''}`}
          />
        </Link>
      </div>
      <nav className="sidebar-nav">
        <ul className="menu-list">
          {menuItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={`menu-item ${location.pathname === item.path || location.pathname.startsWith(item.path + '/') ? 'active' : ''}`}
                title={sidebarCollapsed ? item.label : undefined}
              >
                <span className="menu-icon">{React.createElement(item.Icon as React.ElementType)}</span>
                <span className="menu-label">{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <button className="sidebar-toggle" onClick={toggleSidebar} title={sidebarCollapsed ? 'Expandir menú' : 'Colapsar menú'}>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d={sidebarCollapsed
            ? "M7 4l6 6-6 6"
            : "M13 4l-6 6 6 6"
          } stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
    </aside>
  );
};

export default Sidebar;
